/**
 * Formats milliseconds remaining as "M:SS" (e.g. 245000 -> "4:05").
 * Shared by the checkout tab's payment timer and the booking tab's
 * "checkout open in another tab" card, so both show the same clock.
 * @param {number} ms - milliseconds remaining, may be negative.
 * @returns {string} clamped, zero-padded countdown label.
 */
export const formatCountdown = (ms) => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

/**
 * Milliseconds until an ISO deadline, or null when there is no deadline.
 * @param {string|null|undefined} deadlineIso
 * @returns {number|null}
 */
export const msUntil = (deadlineIso) =>
  (deadlineIso ? new Date(deadlineIso).getTime() - Date.now() : null);
